<div class="container">
    <div class="row justify-content-center">
        <div class="col-col-xl-4 col-lg-6 col-md-8 col-sm-12 mat-elevation-z8">
            <h1 class="heading text-center mat-elevation-z8 coolfont">Verify your E-mail</h1>
            <p>An e-mail has been sent to your E-mail with a verification link</p>
            <p>Please open that link to verify your account</p>
            <p>After that, return to this tab and Sign In to continue to our site</p>
            <p>This page will automatically be redirected to the Sign In page</p>
        </div>
    </div>
</div>